import Urls from 'mangools-commons/dist/constants/Urls';

const PATH = process.env.APP_SUBPATH || '';

const RoutePaths = {
    ROOT: `${PATH}/`,
    DASHBOARD: `${PATH}/dashboard`,
    IMPORT: `${PATH}/import`,
    SW_NEW_TRACKING: `${Urls.SERPWATCHER_APP_URL}/new`,
    KEYWORD_GAP: `${PATH}/keyword-gap`,
    KEYWORD_GAP_RESULTS: `${PATH}/keyword-gap-results`,
};

export default RoutePaths;
